// Used for DEV environment to allow
// pricing tooltips with stepIds
export const ALLOW_TEST_VIEW: string[] = [
  'garant-sa-door-it-prefix-test-number-5@doorit.de',
  'garant-msa-door-it-prefix-test-number-5@doorit.de',
  'pruem-sa-door-it-prefix-test-number-5@doorit.de',
  'pruem-msa-door-it-prefix-test-number-5@doorit.de',
  'garant-msa@doorit.de',
  'garant-sa@doorit.de',
  'pruem-msa@doorit.de',
  'pruem-sa@doorit.de',
  'doorit-garant-msa-testing@arbonia.com',
  'doorit-garant-sa-testing@arbonia.com',
  'doorit-pruem-msa-testing@arbonia.com',
  'doorit-pruem-sa-testing@arbonia.com'
];
